import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { MenuManagementService } from '../menu/services/menu-management.service';
import { AntennaTypes, FeatureType, NavaidFileType } from '../models/EnumTypes';
import { NavaidFile, NavaidModel } from '../models/navaid';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { MapService } from './map.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ModalControlService } from './modal-control.service';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { SearchService } from './search.service';
import { ToolsControlService } from './tools-control.service';
import { UtilsService } from './utils.service';
import { ChannelFreqObject } from 'src/app/models/ChannelFreqObject';
import { FreqConversionUtil } from 'src/app/models/FreqConversionUtil'
import { FilterModel } from '../models/filter';
import { OrFilter } from '../models/OrFilter';
import { AndFilter } from '../models/AndFilter';
import { Observable, Subscription, interval, takeWhile } from 'rxjs';
import { icaoccModel } from '../models/icaoccModel';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import TileWMS from 'ol/source/TileWMS';
import TileLayer from 'ol/layer/Tile';
import olMap from 'ol/Map';
import { CoordenateService } from './coordenate.service';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { sectorizationGraphData } from '../models/sectorizationGraphData';
import { SectorizationDisplayComponent } from '../popup/sectorization-display/sectorization-display/sectorization-display.component';
import { ConfigurationService } from './configuration.service';
import { FacilityModel } from '../models/configuration';
import { LatLonDMS } from '../models/coord-dms';
import * as olProj from 'ol/proj';
import { fromLonLat } from 'ol/proj';
import { UiBlockService } from './ui-block.service';
import Geometry from 'ol/geom/Geometry';
import VectorTileLayer from 'ol/layer/VectorTile';
import { VectorTile } from 'ol/source';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector';
import {containsCoordinate} from 'ol/extent';
import { read } from 'fs';
import { SelectAntennaPatternService } from './select-antenna-pattern.service';

@Injectable({
  providedIn: 'root'
})
export class NavaidsService {

  public active: boolean;
  public selectedNavaid: NavaidModel;
  public selectedNavaidUserDefinedStatus: boolean = false;
  public activeSectorizations: boolean = false;
  public activeAngles: boolean = false;
  public activeSectorizationDisplay: boolean = false;
  public editMode:boolean = false;
  public fullScreenMode:boolean = false;
  map:olMap;
  icaoCountryCode : string;
  icaoCountryCodes : icaoccModel[];
  navaidUpdate:boolean = false;


  informationMessage : string;

  maxYear: number = 2100;
  minYear : number = 1950;
  dateFieldsInvalid = new Map();
  showErrorMessage : boolean = false;
  validDates :boolean= true;

  public colapsableLabelSectorizations: boolean;
  public colapsableDivSectorizations: boolean;

  idValid:boolean = false;
  nameValid:boolean = false;
  icaoValid:boolean = false;
  typeValid:boolean = true
  latValid:boolean = false;
  longValid:boolean = false;
  antHeight:boolean = false;
  elevationValid:boolean = false;
  docValid:boolean = true;
  coneValid:boolean = true;
  mtboValid:boolean = true;
  docMaxAltitudeValid:boolean = true;
  publishedElevationValid: boolean = true;
  antennaHeightValid: boolean = true;
  latitudeValid : boolean = true;
  lat_degreesValid : boolean = true;
  lat_minutesValid : boolean = true;
  lat_secondsValid : boolean = true;
  longitudeValid : boolean = true;
  lon_degreesValid : boolean = true;
  lon_minutesValid : boolean = true;
  lon_secondsValid : boolean = true;

  vorLatitudeValid : boolean = true;
  vorLat_degreesValid : boolean = true;
  vorLat_minutesValid : boolean = true;
  vorLat_secondsValid : boolean = true;
  vorLongitudeValid : boolean = true;
  vorLon_degreesValid : boolean = true;
  vorLon_minutesValid : boolean = true;
  vorLon_secondsValid : boolean = true;
  inpectionIntervalValid : boolean = true;
  vorInpectionIntervalValid : boolean = true;
  vorDocMaxRangeValid : boolean = true;
  ndbFrequencyValid : boolean = true;
  loading: boolean = false;


  constructor(private projectService: ProjectService,
    private pointsController: PointsService,
    private modalService: ModalControlService,
    private modalConfirmation: ModalConfirmationService,
    private popupService : BsModalService,
    private utilsService : UtilsService,
    private http: HttpClient,
    private endpointService : EndpointsService,
    private coordenatedController : CoordenateService,
    private configurationService : ConfigurationService,
    private mapService: MapService,
    private rcsControl : CoordenateService,
    private antennaPatternService: SelectAntennaPatternService
    ) {
    this.map = mapService.getMap('map');
    const checkAuthSubscription: Subscription = interval(100) // ms
      .pipe(takeWhile(() => !this.endpointService.httpOptions, true))
      .subscribe(() => {
        if (this.endpointService.httpOptions) {
          checkAuthSubscription.unsubscribe();
          this.initIcaoCodes();
        }
      });
  }


  initIcaoCodes() {
    this.getAllIcaoCountryCodes().subscribe((icaocodes) => {
      icaocodes.forEach(code => {
        this.pointsController.worldIcaoCodes.push(new icaoccModel(code.countryname, code.fips, code.icaocode ?? 'null', code.iso2code));
        if (code.isecacenp) {
          this.pointsController.ecacEnpIcaoCodes.push(new icaoccModel(code.countryname, code.fips, code.icaocode ?? 'null', code.iso2code));
        }
      });
      this.pointsController.worldIcaoCodes = this.pointsController.worldIcaoCodes.sort((a, b) => (a.countryname > b.countryname) ? 1 : ((b.countryname > a.countryname) ? -1 : 0));
      this.pointsController.ecacEnpIcaoCodes = this.pointsController.ecacEnpIcaoCodes.sort((a, b) => (a.countryname > b.countryname) ? 1 : ((b.countryname > a.countryname) ? -1 : 0));
    });
  }



    setValidationValid(value : boolean) : void {
      this.docValid = value;
      this.docMaxAltitudeValid = value;
      this.publishedElevationValid = value;
      this.antennaHeightValid = value
      this.lat_degreesValid = value;
      this.lat_minutesValid = value;
      this.lat_secondsValid = value;
      this.lon_degreesValid = value;
      this.lon_minutesValid = value;
      this.lon_secondsValid = value;
      this.latitudeValid = value;
      this.longitudeValid = value;
    }
    async openFooter(){
      if (this.antennaPatternService.antennaModels == null || this.antennaPatternService.antennaModels.length == 0){
        await this.antennaPatternService.getAllAntennaModels();
      }
      if (this.selectedNavaid.antennaModelName != null){
        const antennaModelExists: boolean
        = this.antennaPatternService.antennaModels
        .findIndex(a => a.modelName == this.selectedNavaid.antennaModelName) != -1;

        if (!antennaModelExists){
          this.selectedNavaid.antennaModelName = null;
        }

      }
      this.active = true;
    }
    closeFooter(){
      this.active = false;
      this.icaoCountryCode  = null;

    }
    switchFooter(){
      this.active = false;
      this.icaoCountryCode  = null;
    }
    checkDateField(id:String,value){
      var date = new Date(value);
      this.dateFieldsInvalid.set(id,date.getFullYear() > this.maxYear || date.getFullYear() < this.minYear);
      this.validDates = Array.from(this.dateFieldsInvalid.values()).filter((value) => {return value}).length == 0
    }

    createNavaid(navaid?:NavaidModel){
      if (this.projectService.projectEditable()){
        this.setValidationValid(true);
        if(typeof navaid == 'undefined')
          this.initializeDefaultNavaid();
        else
          this.initializeSelectedNavaid(navaid);
                //this.menuService.toogleMenu();
        this.editMode = false;
        this.openFooter();
      }
    }
    initializeDefaultNavaid(){
        this.selectedNavaid = new NavaidModel();
        this.icaoCountryCodes = [];
        this.dateFieldsInvalid = new Map();
        this.validDates = true;
        //set default values
        this.selectedNavaid.navaidtype = "DME";
        this.selectedNavaid.cone = 50.0;

        let facilityConfig : FacilityModel  = this.configurationService.currentConfiguration.facilityConfiguration;
        this.selectedNavaid.antheight =  facilityConfig.antenaMaxHeightFT;
        this.selectedNavaid.antheightMeters = facilityConfig.antenaMaxHeightM;
        this.selectedNavaid.doc = facilityConfig.docMaxRange.toString();
        this.selectedNavaid.maxaltitude = facilityConfig.docMaxAltitudeFT;
        this.selectedNavaid.maxaltitudeMeters = facilityConfig.docMaxAltitudeM;
        this.selectedNavaid.elevationRelativeTerrainFeet = facilityConfig.antenaMaxHeightFT;
        this.selectedNavaid.antennatype = AntennaTypes.OMNIDIRECTIONAL;
        this.selectedNavaid.losthreshold = '0.0';

    }
    initializeDateFieldsInvalid(){
      this.dateFieldsInvalid = new Map();
      var dateFieldsId: string[] = ['infoupdate','operationalsince','dueforreplacement','plannedremoval',
                'lastinspection','voroperationalsince','vordueforreplace','vorplannedremoval','vorlastinsp',
              'vorplannedinspection'];
      dateFieldsId.forEach((dateFieldId) =>{
        this.checkDateField(dateFieldId, this.selectedNavaid[dateFieldId]);
      });

    }
    async initializeSelectedNavaid(navaid:NavaidModel){
      this.icaoCountryCodes = [];
      this.selectedNavaid =  cloneDeep(navaid);
      this.initializeDateFieldsInvalid();
      this.selectedNavaidUserDefinedStatus = !this.selectedNavaid.userdefined;
      if(this.selectedNavaid.channel != null)
        this.defineFrequenciesFromChannel(this.selectedNavaid.channel);
      if(this.selectedNavaid.latLonDms == null){
        this.selectedNavaid.latLonDms = new LatLonDMS();
      }
      this.selectedNavaid.latLonDms.fromLat(this.selectedNavaid.latitude);
      this.selectedNavaid.latLonDms.fromLon(this.selectedNavaid.longitude);
      if(this.selectedNavaid.vorLatLonDms == null){
        this.selectedNavaid.vorLatLonDms = new LatLonDMS();
      }
      this.selectedNavaid.vorLatLonDms.fromLat(this.selectedNavaid.vorlatitude);
      this.selectedNavaid.vorLatLonDms.fromLon(this.selectedNavaid.vorlongitude);
      (await this.pointsController.getTerrainElevation(this.selectedNavaid.latitude, this.selectedNavaid.longitude)).subscribe(
        (data) => {
          this.selectedNavaid.elevationTerrainMeters = data;
          this.selectedNavaid.elevationTerrainFeet = this.pointsController.convertToFeet(data);
          this.selectedNavaid.elevationRelativeTerrainMeters = this.selectedNavaid.elevationTerrainMeters + this.selectedNavaid.antheightMeters;
          this.selectedNavaid.elevationRelativeTerrainFeet = this.selectedNavaid.elevationTerrainFeet + this.selectedNavaid.antheight;

          // Ensure all conversions are calculated
          this.ensureAllConversions();

          this.icaoCountryCodes.push(new icaoccModel('','',this.selectedNavaid.icaocc,''));
          //this.initializeIcaoCodes(this.selectedNavaid.latLonDms.toLat(), this.selectedNavaid.latLonDms.toLon());
        }
      );
    }

    defineEditInitState(navaid:NavaidModel){

      this.initializeSelectedNavaid(navaid)
      this.openFooter();
      this.editMode = true;
      this.setValidationValid(true);
      var element = document.getElementById('vorlatitude');
      var event = new Event('change');
      element.dispatchEvent(event);
      var element = document.getElementById('vorlongitude');
      var event = new Event('change');
      element.dispatchEvent(event);
      this.isValueValid("Cone", navaid.cone);
      this.isValueValid("DOC", navaid.doc);
      this.isValueValid("DOC_Maximum_Altitude", navaid.maxaltitude)
    }

    isValueValid(type : string, value : any) : void {
      if (value != null) {
        switch(type) {
          case "mtbo":
            if (!(Number.parseFloat(value) > 0 && Number.parseFloat(value) <= 100000)) {
              this.mtboValid = false;
            }else {
              this.mtboValid = true;
            }
            break;
          case "Cone":
            if (!(Number.parseFloat(value) >= 5 && Number.parseFloat(value) <= this.configurationService.currentConfiguration.calculation.coneOfSilenceDefa)){
              this.coneValid = false;
            }else {
              this.coneValid = true;
            }
            break;
          case "DOC":
            if (!(Number.parseFloat(value) >= 1 && Number.parseFloat(value) <= this.configurationService.currentConfiguration.facilityConfiguration.docMaxRange)){
              //this.modalService.showMesssageModal('Error', 'The DOC value should be defined between the range 1-350.');
              this.docValid = false;
              //this.selectedNavaid.doc = null;
            }else {
              this.docValid = true;
            }
            break;
          case "DOC_Maximum_Altitude":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= this.configurationService.currentConfiguration.facilityConfiguration.docMaxAltitudeFT)){
              //this.modalService.showMesssageModal('Error', 'The DOC Maximum Altitude value should be defined between the range 0-60000.');
              //this.selectedNavaid.maxaltitude = null;
              //this.selectedNavaid.maxaltitudeMeters = null;
              this.docMaxAltitudeValid = false;
            }else {
              this.docMaxAltitudeValid = true;
            }
            break;
          case "publishedElevation":
            if (!(Number.parseFloat(value) >= -2000 && Number.parseFloat(value) <= 20000)) {
              this.publishedElevationValid = false;
            } else {
              this.publishedElevationValid = true;
            }
            break;

          case "antennaHeight":
            const maxAntenna = this.configurationService.currentConfiguration.facilityConfiguration.antenaMaxHeightFT;
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= maxAntenna)) {
              this.antennaHeightValid = false;
            } else {
              this.antennaHeightValid = true;
            }
            break;
          case "latitude":
            this.setValidationValid(true);
            if (!(Number.parseFloat(value) >= -90 && Number.parseFloat(value) <= 90)){

              this.selectedNavaid.latitude = null;
              //this.selectedNavaid.latLonDms.latitude.degrees = null;
              //this.selectedNavaid.latLonDms.latitude.minutes = null;
              //this.selectedNavaid.latLonDms.latitude.seconds = null;
              this.latitudeValid = false;
            }else {
              this.latitudeValid = true;
            }
            break;
          case "lat_degrees":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 90 && Number.isInteger(value))){

              //this.selectedNavaid.latLonDms.latitude.degrees = null;
              this.lat_degreesValid = false;
            }else {
              this.lat_degreesValid = true;
            }
            break;
          case "lat_minutes":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59 && Number.isInteger(value))){

              //this.selectedNavaid.latLonDms.latitude.minutes = null;
              this.lat_minutesValid = false;
            }else {
              this.lat_minutesValid = true;
            }
            break;
          case "lat_seconds":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59.99)){

              //this.selectedNavaid.latLonDms.latitude.seconds = null;
              this.lat_secondsValid = false;
            }else {
              this.lat_secondsValid = true;
            }
            break;
          case "longitude":
            this.setValidationValid(true);
            if (!(Number.parseFloat(value) >= -180 && Number.parseFloat(value) <= 180)){

              //this.selectedNavaid.longitude = null;
              //this.selectedNavaid.latLonDms.longitude.degrees = null;
              //this.selectedNavaid.latLonDms.longitude.minutes = null;
              //this.selectedNavaid.latLonDms.longitude.seconds = null;
              this.longitudeValid = false;
            }else {
              this.longitudeValid = true;
            }

            break;
          case "lon_degrees":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 180 && Number.isInteger(value))){

              //this.selectedNavaid.latLonDms.longitude.degrees = null;
              this.lon_degreesValid = false;
            }else {
              this.lon_degreesValid = true;
            }
            break;
          case "lon_minutes":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59 && Number.isInteger(value))){

              //this.selectedNavaid.latLonDms.longitude.minutes = null;
              this.lon_minutesValid = false;
            }else {
              this.lon_minutesValid = true;
            }
            break;
          case "lon_seconds":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59.99)){

              //this.selectedNavaid.latLonDms.longitude.seconds = null;
              this.lon_secondsValid = false;
            }else {
              this.lon_secondsValid = true;
            }
            break;
            case "vorlatitude":
              this.setValidationValid(true);
              if (!(Number.parseFloat(value) >= -90 && Number.parseFloat(value) <= 90)){

                this.selectedNavaid.latitude = null;
                //this.selectedNavaid.latLonDms.latitude.degrees = null;
                //this.selectedNavaid.latLonDms.latitude.minutes = null;
                //this.selectedNavaid.latLonDms.latitude.seconds = null;
                this.vorLatitudeValid = false;
              }else {
                this.vorLatitudeValid = true;
              }
              break;
            case "vorLatDegrees":
              if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 90 && Number.isInteger(value))){

                //this.selectedNavaid.latLonDms.latitude.degrees = null;
                this.vorLat_degreesValid = false;
              }else {
                this.vorLat_degreesValid = true;
              }
              break;
            case "vorLatMinutes":
              if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59 && Number.isInteger(value))){

                //this.selectedNavaid.latLonDms.latitude.minutes = null;
                this.vorLat_minutesValid = false;
              }else {
                this.vorLat_minutesValid = true;
              }
              break;
            case "vorLatSeconds":
              if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59.99)){

                //this.selectedNavaid.latLonDms.latitude.seconds = null;
                this.vorLat_secondsValid = false;
              }else {
                this.vorLat_secondsValid = true;
              }
              break;
            case "vorlongitude":
              this.setValidationValid(true);
              if (!(Number.parseFloat(value) >= -180 && Number.parseFloat(value) <= 180)){

                //this.selectedNavaid.longitude = null;
                //this.selectedNavaid.latLonDms.longitude.degrees = null;
                //this.selectedNavaid.latLonDms.longitude.minutes = null;
                //this.selectedNavaid.latLonDms.longitude.seconds = null;
                this.vorLongitudeValid = false;
              }else {
                this.vorLongitudeValid = true;
              }

              break;
            case "vorLonDegrees":
              if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 180 && Number.isInteger(value))){

                //this.selectedNavaid.latLonDms.longitude.degrees = null;
                this.vorLon_degreesValid = false;
              }else {
                this.vorLon_degreesValid = true;
              }
              break;
            case "vorLonMinutes":
              if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59 && Number.isInteger(value))){

                //this.selectedNavaid.latLonDms.longitude.minutes = null;
                this.vorLon_minutesValid = false;
              }else {
                this.vorLon_minutesValid = true;
              }
              break;
            case "vorLonSeconds":
              if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59.99)){

                //this.selectedNavaid.latLonDms.longitude.seconds = null;
                this.vorLon_secondsValid = false;
              }else {
                this.vorLon_secondsValid = true;
              }
              break;
          case "inpectioninterval":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 2.14748365e9)){

              //this.selectedNavaid.latLonDms.longitude.seconds = null;
              this.inpectionIntervalValid = false;
            }else {
              this.inpectionIntervalValid = true;
            }
            break;
          case "vorinpectioninterval":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 2.14748365e9)){

              //this.selectedNavaid.latLonDms.longitude.seconds = null;
              this.vorInpectionIntervalValid = false;
            }else {
              this.vorInpectionIntervalValid = true;
            }
            break;
          case "vordocmaxrange":
            if (!(Number.parseFloat(value) >= 1 && Number.parseFloat(value) <= 500)){

              //this.selectedNavaid.latLonDms.longitude.seconds = null;
              this.vorDocMaxRangeValid = false;
            }else {
              this.vorDocMaxRangeValid = true;
            }
            break;
          case "ndbfrequency":
            if (!(Number.parseFloat(value) >= 190 && Number.parseFloat(value) <= 1750)){

              //this.selectedNavaid.latLonDms.longitude.seconds = null;
              this.ndbFrequencyValid = false;
            }else {
              this.ndbFrequencyValid = true;
            }
            break;

          default:
            break;
        }
      }
    }





    getEditNavaidFeatures(){
      let features : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
      if(features.length > 0){
        return features;
      }
      this.modalService.showMesssageModal("Warning", "Select at least 1 Navaid to edit.");


    }

    addNavaidFile(file: File, navaidfileType: string){
      let navaidFile: NavaidFile = new NavaidFile();
      navaidFile.fileName = file.name;
      navaidFile.fileType =  navaidfileType;
      navaidFile.navaidId = +this.selectedNavaid.id;
      const reader = new FileReader();
      let thisVar = this;
      reader.onload = function (event) {
        try{

          if (event.target && event.target.result instanceof ArrayBuffer) {
            const uint8ArrayData = new Uint8Array(event.target.result);

            // Convert Uint8Array to base64 representation
            navaidFile.fileData = btoa( uint8ArrayData.reduce((data, byte) => data + String.fromCharCode(byte), ''))

            if(thisVar.selectedNavaid.navaidFiles == null){
              thisVar.selectedNavaid.navaidFiles = [];
            }
            thisVar.selectedNavaid.navaidFiles.push(navaidFile);
          }
        }catch(error){
          thisVar.modalService.showMesssageModal("Error",error);
        }
      };
        reader.readAsArrayBuffer(file);
    }
    //open edit tab without tabs
    editNavaid(){
      this.icaoCountryCodes = [];
      if (!this.projectService.projectEditable()){
        return;
      }
      let features : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
      let navaid: NavaidModel;
      if(features.length > 1){
        const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
          backdrop: 'static' // Prevent closing on backdrop click
        });
        bsModalRef.content.entity = "Navaids";
        bsModalRef.content.type = "Edit";
        bsModalRef.content.selectAllActive = false;
        bsModalRef.content.data = features;
        bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");

        bsModalRef.content.onClose.subscribe(result => {
          if(result.length == 1){
            let feature : any = this.pointsController.getSelectedFeatures().find(feat => feat.get("id") == result[0].id && feat.get("featureType") == FeatureType.Navaid);
            navaid = this.pointsController.transformFeatureInNavaid(feature)
            this.defineEditInitState(navaid);
            return navaid.id;
          }
        });
      }
      else if (features.length == 1){
        navaid = this.pointsController.transformFeatureInNavaid(features[0])
        this.defineEditInitState(this.pointsController.transformFeatureInNavaid(features[0]));
        return navaid.id;
      }else{
        this.modalService.showMesssageModal("Warning", "Select at least 1 Navaid to edit.");

      }
    }

    deleteNavaids(){
      if (!this.projectService.projectEditable()){
        return;
      }
      let features : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid);
      if(features.length == 0){
        this.modalService.showMesssageModal("Warning", "Select at least 1 Navaid to delete.");
        return;
      }
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Navaids";
      bsModalRef.content.type = "Delete";
      bsModalRef.content.selectAllActive = true;
      bsModalRef.content.data = features;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Navaids");
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length>0){
          this.modalConfirmation.showMesssageConfirmationModal("Delete Navaid", "Do you want to delete the selected NavAids?", "Yes", "No", () => this.pointsController.deleteNavaids(result));
        }
      });
      //this.menuService.toogleMenu();
    }


  getNavaidPayload( navaid: NavaidModel) {
    let navaidPayload:NavaidModel = <NavaidModel><unknown>{
      "antennatype":navaid.antennatype,
      "antheight":navaid.antheight,
      "arinc424fom":navaid.arinc424fom,
      "bias":navaid.bias,
      "cableloss":navaid.cableloss,
      "channel":navaid.channel,
      "cone":navaid.cone,
      "declaredeirp":navaid.declaredeirp,
      "dmetacanclass":navaid.dmetacanclass,
      "doc":navaid.doc,
      "dueforreplacement": moment(navaid.dueforreplacement).isValid() ? moment(navaid.dueforreplacement).format('yyyy-MM-DD') : null,
      "elevation":navaid.elevation,
      "equipmenttype":navaid.equipmenttype,
      "fligthinspectioninterval":navaid.fligthinspectioninterval,
      "icaocc":navaid.icaocc,
      "id":navaid.id,
      "infosrce":navaid.infosrce,
      "infoupdate": moment(navaid.infoupdate).isValid() ? moment(navaid.infoupdate).format('yyyy-MM-DD') : null,
      "lastinspection": moment(navaid.lastinspection).isValid() ? moment(navaid.lastinspection).format('yyyy-MM-DD') : null,
      "latitude":navaid.latitude,
      "longitude":navaid.longitude,
      "losthreshold":navaid.losthreshold,
      "manufacturer":navaid.manufacturer,
      "maxaltitude":navaid.maxaltitude,
      "maxload":navaid.maxload,
      "meetingpost1989sarps":navaid.meetingpost1989sarps,
      "model":navaid.model,
      "mtbo":navaid.mtbo,
      "name":navaid.name,
      "navaidid":navaid.navaidid,
      "navaidtype":navaid.navaidtype,
      "ndbfrequency":navaid.ndbfrequency,
      "notes":navaid.notes,
      "notupdate":navaid.notupdate,
      "offsetdist":navaid.offsetdist,
      "operationalsince": moment(navaid.operationalsince).isValid() ? moment(navaid.operationalsince).format('yyyy-MM-DD') : null,
      "operationalstatus":navaid.operationalstatus,
      "operator":navaid.operator,
      "plannedinspection": moment(navaid.plannedinspection).isValid() ? moment(navaid.plannedinspection).format('yyyy-MM-DD') : null,
      "plannedremoval": moment(navaid.plannedremoval).isValid() ? moment(navaid.plannedremoval).format('yyyy-MM-DD') : null,
      "quiescentsquitterrate":navaid.quiescentsquitterrate,
      "sectorizationtext":navaid.sectorizationtext,
      "transmoutpower":navaid.transmoutpower,
      "updated":navaid.updated,
      "userdefined":navaid.userdefined,
      "usesectorization":navaid.usesectorization,
      "vordocmaxrange":navaid.vordocmaxrange,
      "vordueforreplace": moment(navaid.vordueforreplace).isValid() ? moment(navaid.vordueforreplace).format('yyyy-MM-DD') : null,
      "vorinpectioninterval":navaid.vorinpectioninterval,
      "vorlastinsp": moment(navaid.vorlastinsp).isValid() ? moment(navaid.vorlastinsp).format('yyyy-MM-DD') : null,
      "vorlatitude": navaid.vorlatitude,
      "vorlongitude": navaid.vorlongitude,
      "vormanufacturer":navaid.vormanufacturer,
      "vormodel":navaid.vormodel,
      "voroperationalsince": moment(navaid.voroperationalsince).isValid() ? moment(navaid.voroperationalsince).format('yyyy-MM-DD') : null,
      "voroperstatus":navaid.voroperstatus,
      "vorplannedinspection": moment(navaid.vorplannedinspection).isValid() ? moment(navaid.vorplannedinspection).format('yyyy-MM-DD') : null,
      "vorplannedremoval": moment(navaid.vorplannedremoval).isValid() ? moment(navaid.vorplannedremoval).format('yyyy-MM-DD') : null,
      "vortype":navaid.vortype,
      "sectorizations":navaid.sectorizations,
      "associatedProcedures":navaid.associatedProcedures,
      "associatedAirspaceBoundaries":navaid.associatedAirspaceBoundaries,
      "actualScreeningAngle":navaid.actualScreeningAngle,
      "inspectionRepPath":{},
      "antennaDiagramPath":{},
      "vorInspectionRepPaths":[],
      "isItu":navaid.isItu,
      "navaidFiles": navaid.navaidFiles,
      "antennaModelName": navaid.antennaModelName

      //cable loss nor present
    }

    return navaidPayload;
  }

  defineFrequencies(value : string) : void {
    let channelFreqObject : ChannelFreqObject = null;
    if(this.selectedNavaid.vhfTunFreqInput != null){
      channelFreqObject = FreqConversionUtil.findByVorFrequency(Number.parseFloat(this.selectedNavaid.vhfTunFreqInput));
    }

    if(channelFreqObject != null){
      this.selectedNavaid.uhfDownlinkFreqInput = channelFreqObject.downlinkFreq;
      this.selectedNavaid.uhfUplinkFreqInput = channelFreqObject.uplinkFreq;
      this.selectedNavaid.channel = channelFreqObject.channel;
    }
    else if(this.selectedNavaid.vhfTunFreqInput == null && this.selectedNavaid.channel == null){
      this.selectedNavaid.uhfDownlinkFreqInput = null;
      this.selectedNavaid.uhfUplinkFreqInput = null;
    }
}

defineFrequenciesFromChannel(value : string) : void {
  let channelFreqObject : ChannelFreqObject = null;
  if(value != null){
    channelFreqObject = FreqConversionUtil.findByChannel(value);
  }

  if(channelFreqObject != null){
    if(channelFreqObject.vorFreq != null){
      this.selectedNavaid.vhfTunFreqInput = channelFreqObject.vorFreq.toString();
    }
    else{
      this.selectedNavaid.vhfTunFreqInput = null;
    }
    this.selectedNavaid.uhfUplinkFreqInput = channelFreqObject.uplinkFreq;
    this.selectedNavaid.uhfDownlinkFreqInput = channelFreqObject.downlinkFreq;
  }

  else if(this.selectedNavaid.vhfTunFreqInput == null && this.selectedNavaid.channel == null){
    this.selectedNavaid.uhfDownlinkFreqInput = null;
    this.selectedNavaid.uhfUplinkFreqInput = null;
  }
}

  getValidationMsg(num : string) : string {
		let msgInvalid : string = "Frequency must be a multiple of 0.05 between: " + 108 +
								" and 117.95001F";
		try{

			if((num.length - num.indexOf(".")) > 3){
				return msgInvalid;
			}

			if((num == null) || (Math.abs(this.IEEEremainder(Number.parseFloat(num), 0.05)) > 0.001)){
				return msgInvalid;
			}
		}
		catch (error)
    {
      return msgInvalid;
    }

		return null;
	}

  IEEEremainder(f1 : number, f2 : number) : number
  {
      let hex: number = 0xf00d;
      let div : number = Math.round(f1 / f2);
      return f1 - (div * f2);
  }



	getMinDateFromFilter(filter : FilterModel) : Date {
		let stringDate : string = filter.value.substring(0, filter.value.indexOf("<") - 1);
		let date : Date = null;
		try {
			date = new Date(stringDate);
		} catch (e) {
			e.printStackTrace();
		}
		return date;
	}

	getMaxDateFromFilter(filter : FilterModel) : Date {
		let first : number = filter.value.indexOf("<");
		let second : number = filter.value.indexOf("<", first + 1);
		let stringDate : string = filter.value.substring(second + 2, filter.value.length);

		let date : Date = null;
		try {
			date = new Date(stringDate);
		} catch (e) {
			e.printStackTrace();
		}
		return date;
	}


  getIcaoccByIsocode2(isocode2 : string): Promise<icaoccModel[]> {
    return this.http.get<icaoccModel[]>(
      this.endpointService.icaoccUrl + "/" + isocode2,
      this.endpointService.httpOptions
    ).toPromise();
  }

  getIcaoccByIsocode2Observable(isocode2 : string): Observable<icaoccModel[]> {
    return this.http.get<icaoccModel[]>(
      this.endpointService.icaoccUrl + "/" + isocode2,
      this.endpointService.httpOptions
    );
  }

  getIcaoccByIsocode2Bulk(isocodes2 : string[]): Promise<ArrayBuffer> {
    let isocodes2ToSend: string = isocodes2[0];
    for (let i = 1; i<isocodes2.length; i++){
      isocodes2ToSend += ';' + isocodes2[i];
    }
    return this.http.request<ArrayBuffer>( "REQUEST",
      this.endpointService.icaoccGetByIsoCode2Bulk, {
        body: isocodes2ToSend,
        headers : this.endpointService.httpOptions.headers,
        responseType: 'json'
      }).toPromise();
  }



  getAllIcaoCountryCodes(): Observable<icaoccModel[]> {
    return this.http.get<icaoccModel[]>(
      this.endpointService.icaoccUrl,
      this.endpointService.httpOptions
    );
  }

  getSectorizationDisplay(){
    let sectData : sectorizationGraphData = new sectorizationGraphData(this.pointsController.getNavaidPayload(this.selectedNavaid), parseFloat(this.selectedNavaid.doc), 0, this.selectedNavaid.maxaltitude, 0);
    return this.http.post(
          this.endpointService.sectorizationDisplayUrl,
          sectData,
          this.endpointService.httpOptions
    ).subscribe(
      (data: sectorizationGraphData) => {
        const bsModalRef : BsModalRef = this.popupService.show(SectorizationDisplayComponent);
        bsModalRef.content.sectorizationData = data;
      },
      (error) => {
        //return 'error';
        return null;
      }
    );
  }

  initializeIcaoCodes(lat : number, lon : number) : Promise<void> {
    var viewResolution = /** @type {number} */ (this.map.getView().getResolution());

    const wmsSource = new TileWMS({
      url: 'https://docker11723-dev-demeter.jelastic.labs.gmv.com/geoserver/DEMETER/wms',
      params: {'LAYERS': 'DEMETER:world', 'TILED': true},
      serverType: 'geoserver',
      crossOrigin: 'anonymous',
    });

    const wmsLayer = new TileLayer({
      source: wmsSource,
    });

    var feature = wmsSource.getFeatureInfoUrl(
      [lon,lat],
      viewResolution,
      this.coordenatedController.activeRCS.epsg,
      {'INFO_FORMAT': 'application/json'}
    );

    if (feature) {
      return fetch(feature)
        .then((response) => response.text())
        .then((html) => {
          const data = JSON.parse(html);
          if(data.features.length > 0){
            this.icaoCountryCode = data.features[0].properties.ISO2_CODE;
          }
        });
    }
  }

  async getIcaoContryCode() : Promise<void> {
    this.icaoCountryCodes = [];
    this.selectedNavaid.icaocc = null;
    this.icaoCountryCode = null;
    let coords = fromLonLat([this.selectedNavaid.longitude,this.selectedNavaid.latitude],this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");

    this.initializeIcaoCodes(coords[1],coords[0]).then(async () =>{
      let icaocodes = await this.getIcaoccByIsocode2(this.icaoCountryCode);
      if (icaocodes != null && icaocodes.length > 0){
        this.icaoCountryCodes = icaocodes;
        this.selectedNavaid.icaocc = icaocodes[0].icaocode;
      }
    });
  }


  public feetToMeters(feet:any){
    return feet * 0.3048;
  }


  async getIcaoCodesFromLatLon(lat : number, lon : number) : Promise<string> {
    var viewResolution = /** @type {number} */ (this.map.getView().getResolution());

    var toReturn;

    const wmsSource = new TileWMS({
      url: 'https://docker11723-dev-demeter.jelastic.labs.gmv.com/geoserver/DEMETER/wms',
      params: {'LAYERS': 'DEMETER:world', 'TILED': true},
      serverType: 'geoserver',
      crossOrigin: 'anonymous',
    });

    const wmsLayer = new TileLayer({
      //extent: [-13884991, 2870341, -7455066, 6338219],
      source: wmsSource
    });


    let coordinate = [lon, lat]
    coordinate = olProj.transform(coordinate, 'EPSG:4326',this.coordenatedController.activeRCS.epsg);

    var feature = wmsSource.getFeatureInfoUrl(
      coordinate,
      viewResolution,
      this.coordenatedController.activeRCS.epsg,
      {'INFO_FORMAT': 'application/json'}
    );
    if (feature) {
      let response = await fetch(feature).then((response) => response.text());
      const allFeatures = JSON.parse(await response);
      if(allFeatures.features.length > 0){
        toReturn = allFeatures.features[0].properties.ISO2_CODE;
      }

    }
    return toReturn
  }

  async fillIso2CodesForNavaidsList (navaids: NavaidModel[]): Promise<void>{
    // TODO: REPLACE FOR STATIC LAYER ON MAP
    const url = (
      'https://docker11723-dev-demeter.jelastic.labs.gmv.com/geoserver/DEMETER/ows?' +
      new URLSearchParams({'service': 'WFS', 'version':'1.0.0',
      'request': 'GetFeature','typeName': 'DEMETER:world',
      'maxFeatures':'300', 'outputFormat':'application/json'} ).toString()
    );

    // send request to geoServer and read features to add to list
    let response = await fetch(url)
    .then(function (response) {
      return response.text();
    })
    //search names in geoJSON to add to table
    var vectorSource = new VectorSource({
      features: new GeoJSON().readFeatures(response, {
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
        dataProjection: 'CRS:84',
      }),
      format: new GeoJSON({
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
        dataProjection: 'CRS:84',
      }),
    });

    let foundFeature: boolean;
    let j: number;
    const featuresList = vectorSource.getFeatures();
    if (featuresList != null && featuresList.length > 0){
      for (let i = 0; i< navaids.length; i++){
        if (!(navaids[i].icaocc == null || navaids[i].icaocc == "")){
          continue;
        }
        const coordinate = olProj.transform([navaids[i].longitude, navaids[i].latitude], 'EPSG:4326',this.coordenatedController.activeRCS.epsg);
        j = 0;
        foundFeature = false;
        while (!foundFeature && j<featuresList.length){
          if (containsCoordinate(featuresList[j].getGeometry().getExtent(), coordinate)){
            const iso2code = featuresList[j].getProperties().ISO2_CODE;
            if (iso2code != null){
              navaids[i].icaocc = featuresList[j].getProperties().ISO2_CODE;
              foundFeature = true;
            }
          }
          j++;
        }
        if (!foundFeature){
          // remove navaid from list
          navaids.splice(i, 1);
          i--;
        }

      }
    }

  }

  public ensureAllConversions(): void {
    const n = this.selectedNavaid;
    if (!n) {
      return;
    }

    // Published Elevation
    if (n.elevation != null && (n.elevationMeters == null || isNaN(+n.elevationMeters))) {
      n.elevationMeters = this.pointsController.convertToMeters(+n.elevation).toString();
    }

    // Terrain Relative Elevation
    if (n.elevationRelativeTerrainFeet != null &&
        (n.elevationRelativeTerrainMeters == null || isNaN(+n.elevationRelativeTerrainMeters))) {
      n.elevationRelativeTerrainMeters = this.pointsController.convertToMeters(+n.elevationRelativeTerrainFeet);
    }

    // Antenna Height
    if (n.antheight != null && (n.antheightMeters == null || isNaN(+n.antheightMeters))) {
      n.antheightMeters = this.pointsController.convertToMeters(+n.antheight);
    }

    // Terrain Elevation
    if (n.elevationTerrainFeet != null &&
        (n.elevationTerrainMeters == null || isNaN(+n.elevationTerrainMeters))) {
      n.elevationTerrainMeters = this.pointsController.convertToMeters(+n.elevationTerrainFeet);
    }

    // DOC Maximum Altitude
    if (n.maxaltitude != null && (n.maxaltitudeMeters == null || isNaN(+n.maxaltitudeMeters))) {
      n.maxaltitudeMeters = this.pointsController.convertToMeters(+n.maxaltitude);
    }
  }

}
